import React from "react";
import { UserOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import { ROLE } from "../../shared/constant";
import dateUtils from "../../utils/dateUtils";
import globalUtils from "../../utils/globalUtils";
import clapUtils, { isClapAdminORClapManager } from "../../utils/clapUtils";

const ClientProfile = ({ client, type }: { client: any; type?: string }) => {
  const { userDetails } = useSelector((state: RootState) => state.user);

  return (
    <div className="col-span-1 flex gap-5">
      <div className="default-border w-[90px] h-[90px] min-w-[90px]  min-h-[90px] flex items-center justify-center">
        {globalUtils.isPhotoExist(client?.client_logo) ? (
          <img
            className="max-w-[90px] max-h-[90px]"
            src={client?.client_logo}
            alt="Client logo"
          />
        ) : (
          <UserOutlined style={{ fontSize: 60 }} className="text-secondary" />
        )}
      </div>
      <div className="space-y-2">
        <div className="flex gap-x-2.5">
          <div className="text-heading20 font-bold">
            {client?.name || "___"}
          </div>
          <div className="pt-1">
            {client && clapUtils.getClientTypes(client.client_types)}
          </div>
        </div>
        <div className="flex gap-2">
          <div className="text-secondary">Income Share: </div>
          <div>
            {client &&
              clapUtils.getIncomeShare(
                client.display_income_share,
                client.client_types,
              )}
          </div>
        </div>
        <div className="flex gap-6">
          {client?.display_clap_service_charge.is_service_charge_visible && (
            <div className="flex gap-2">
              <div className="text-secondary">CLAP charges: </div>
              <div>
                {client?.display_clap_service_charge.clap_service_charge}%
              </div>
            </div>
          )}
          {isClapAdminORClapManager(userDetails) && (
            <div className="flex gap-2">
              <div className="text-secondary">Export permission: </div>
              {client ? (
                <div>
                  {client?.has_export_permission ? "Enabled" : "Disabled"}
                </div>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
        {type !== ROLE.ACCOUNTS && client?.last_payment && (
          <div className="flex gap-2">
            <div className="text-secondary">Last Payment Period: </div>
            {/* TODO change it to last_invoice */}
            {dateUtils.defaultFormat(client.last_payment)}
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientProfile;
